import 'assets/css/index.sass'

const Tax = props => props.children

export default Tax
